<template>
    <div class="area-page-wrapper">
        <div class="area-page-container">
            <!-- Header Section -->
            <div class="page-header">
                <h3 class="page-title">Arera</h3>
            </div>
            <!-- <div class="filter-section">
                <div class="search-container">
                    <input type="text" placeholder="Search..." class="search-input" v-model="searchTerm" />
                    <div class="filter-buttons">
                        <PrimeButton icon="pi pi-filter" class="filter-button" @click="openFilterModal" />
                        <PrimeButton icon="pi pi-refresh" class="reset-button" @click="resetFilters" />
                    </div>
                </div>
            </div> -->
            <div class="datatable-container">
                <PrimeDataTable :value="entries" 
                                :paginator="true" 
                                :rows="10" 
                                dataKey="id" 
                                filterDisplay="menu" 
                                class="file-table"
                                paginatorPosition="bottom"
                                responsiveLayout="scroll">
                    <PrimeColumn field="descrizione" header="Raccolta" sortable style="min-width: 14rem;" />
                    <PrimeColumn field="periodo" header="Periodo" sortable style="min-width: 10rem">
                        <template #body="{ data }">{{ data.periodo }}</template>
                    </PrimeColumn>
                    <PrimeColumn field="reparto" header="Reparto" sortable style="min-width: 10rem">
                        <template #body="{ data }">{{ data.reparto }}</template>
                    </PrimeColumn>
                    <PrimeColumn field="last" header="Scad.Ultima Istanza" sortable style="min-width: 10rem">
                        <template #body="{ data }">{{ formatDate(data.last) }}</template>
                    </PrimeColumn>
                    <PrimeColumn header="Azioni" style="min-width: 10rem">
                        <template #body="{ data }">
                            <PrimeButton icon="pi pi-eye"
                                class="p-button p-button-rounded p-button-info custom-eye-button small-button"
                                @click="goToDetail(data.id)" tooltip="View Details" tooltipOptions="{ position: 'top' }" />
                        </template>
                    </PrimeColumn>
                    <PrimeColumn field="stato" header="Stato" sortable style="min-width: 10rem">
                        <template #body="{ data }">
                            <div class="status-icon" :class="data.nistinc > 0 ? 'red' : 'green'">
                                <span>{{ data.nistinc }}</span>
                            </div>
                        </template>
                    </PrimeColumn>
                </PrimeDataTable>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from "vue";
import axios from "axios";
import { useRouter, useRoute } from 'vue-router';
// Aggiungi questi import
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default {
    components: {
        PrimeButton: Button,
        PrimeDataTable: DataTable,
        PrimeColumn: Column
    },
    setup() {
        const entries = ref([]);
        const router = useRouter(); // Inizializza il router
        const route = useRoute();
        const goToDetail = (id) => {
            router.push({
                name: "DettaglioRaccolta",
                params: { id: id }
            });
        };

        const fetchRaccoltaDati = async () => {
            try {
                const response = await axios.post("http://127.0.0.1:8001/api/getRDIStatus");
                console.log("Dati ricevuti:", response.data);
                entries.value = response.data.data;
            } catch (error) {
                console.error("big:", error);
            }
        };

        // Funzione per formattare le date
        const formatDate = (date) => {
            if (!date) return '';
            return new Intl.DateTimeFormat('it-IT', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            }).format(new Date(date));
        };

        const editEntry = (entry) => {
            alert(`Editing entry: ${entry.descrizione}`);
        };

        const deleteEntry = (entry) => {
            if (confirm(`Are you sure you want to delete: ${entry.descrizione}?`)) {
                entries.value = entries.value.filter((e) => e.id !== entry.id);
            }
        };

        onMounted(() => {
            fetchRaccoltaDati();
        });

        return {
            entries,
            goToDetail,
            formatDate,
            editEntry,
            deleteEntry,
        };
    },
};
</script>

<style>
.area-page-wrapper {
    width: 100%;
    padding: 20px;
}

.area-page-container {
    padding: 2rem;
    display: flex;
    flex-direction: column;
}

.page-title {
    text-align: center;
    margin: 10px 0 20px 0;
    font-size: 25px;
    color: var(--text-primary);
    font-weight: 600;
    padding-bottom: 10px;
    border-bottom: 2px solid var(--border-color);
}

.filter-section {
    padding: 0.75rem;
    margin-bottom: 0.5rem;
    border-radius: 0 0 10px 10px;
}

.filter-buttons {
    display: flex;
    gap: 0.5rem;
}

.datatable-container {
    width: 100%;
    overflow-x: auto;
    margin-bottom: 2rem;
}

.p-datatable {
    border-radius: 10px;
    overflow: hidden;
    width: 100%;
    text-align: left;
}

.p-datatable .p-datatable-tbody>tr>td {
    text-align: left;
    border: 1px solid #e5e7eb;
    border-width: 0 0 1px 0;
    margin-left: 5px !important;
    padding: 1rem 1.5rem !important;
}

.p-datatable .p-column-header-content {
    font-weight: 600;
    color: #2c3e50;
    padding: 1rem;
}

.p-datatable-tbody td {
    padding: 0.75rem !important;
    transition: background-color 0.2s ease;
}

.p-datatable-tbody tr:hover {
    background-color: #f1f4f6 !important;
}

.custom-eye-button {
    background-color: #448c94;
    color: white;
    border: none;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.custom-eye-button:hover {
    background-color: #2c5e65;
    transform: scale(1.1);
}

.status-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: white;
    font-weight: bold;
    font-size: 0.9rem;
    text-align: center;
}

.status-icon.red {
    background-color: red;
}

.status-icon.green {
    background-color: green;
}

.p-datatable .p-sortable-column .p-sortable-column-icon {
    color: #ffffff;
    margin-left: 0.5rem;
}

/* Fix for paginator */
.p-paginator {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 1rem;
}

.p-paginator-bottom {
    border-top: 1px solid #e5e7eb;
    padding-top: 0.5rem;
}

@media screen and (max-width: 768px) {
    .area-page-wrapper {
        margin-left: 50px;
        width: calc(100% - 60px);
        padding: 10px;
    }

    .area-page-container {
        padding: 1rem;
    }

    .search-container {
        flex-direction: column;
        gap: 0.5rem;
    }
    
    .p-datatable .p-datatable-tbody>tr>td {
        padding: 0.75rem 1rem !important;
    }
}
</style>